<template>
  <div>
    <v-card
      flat
      dense
      text
      class="pb-2"
      v-if="readOnly && !isEmpty"
    >
      <div class="d-flex pa-2">
        <eva-big-icon
          icon="mdi-comment-question-outline"
          size="20"
          color="blue"
        />
        <span class="subtitle-2 ml-2">{{ $t('live.correction.supportComment.label') }}</span>
        <v-spacer />
      </div>
      <v-divider />
      <v-card-text>
        <katex
          :expr="content"
          class="ml-5"
        />
      </v-card-text>
    </v-card>
    <eva-comment-editor
      v-if="!readOnly"
      :content="content"
      @click:save="save"
      :label="$t('live.correction.supportComment.label')"
      :placeholder="$t('live.correction.supportComment.placeholder')"
      :save-label="$t('live.correction.supportComment.save')"
      icon="mdi-comment-question-outline"
    />
    <slot
      name="append"
      v-if="!isEmpty || !readOnly"
    />
  </div>
</template>

<script>
import EvaCommentEditor from "@/components/quiz/correction/EvaCommentEditor.vue"
import EvaBigIcon from "@/components/shared/eva-big-icon.vue"
import Katex from "@/components/katex-md.vue"
import stringHelpers from "@/helpers/string_helpers"
export default {
  name: "SupportCommentEditor",
  components: { EvaCommentEditor, EvaBigIcon, Katex },
  props: {
    content: { type: String, required: false, default: "" },
    readOnly: { type: Boolean, required: false, default: false },
  },
  emits: ["save"],
  computed: {
    isEmpty() {
      return stringHelpers.isEmptyHtml(this.content)
    },
  },
  methods: {
    save(comment) {
      this.$emit("save", comment)
    },
  },
  watch: {
    "content": {
      handler(val) {
        this.comment = val
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
</style>
